<template>
	<div>
		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
        <el-row :gutter="10" >
          <el-col :span="14">
            <el-input v-model="searchValue" placeholder="登录名/登录邮箱/手机号/单位/姓/名/昵称" size="small" style="width:78%"
                      prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="search()" clearable/>
            <el-button type="primary" icon="el-icon-search" size="small"  style="width:15%"
                       @click.stop="search()">搜索
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select v-if="userTypefilterOptions.length > 0" style="width:100px" v-model="curUserTypeFilterOption" placeholder="用户类型" clearable
                       @change="changeUserTypeOption">
              <el-option v-for="item in userTypefilterOptions" :key="item.value" :value="item.value"
                         :label="item.name" />
            </el-select>
          </el-col>
          <el-col :span="11">
            <el-date-picker v-model="searchDateRange" type="daterange" style="width:100%;margin-top:3px"
                            range-separator="-" start-placeholder="注册起始时间" end-placeholder="注册结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" unlink-panels :picker-options="pickerOptions"
                            @change="search()" />
          </el-col>
        </el-row>
			</div>
			<div style="align-items: flex-end;">
				<el-button type="primary" size="small" @click="addUserDlg = true" style="margin-left:10px">新增用户</el-button>
				<el-button type="success" size="small" @click="export2Excel" :loading="exportLoading" style="margin-top:1px">导出excel
				</el-button>
			</div>

		</div>

		<!-- 内容 -->
		<el-table ref="allUserList" v-loading="loading" :data="allUserList"
			:header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px" border>

			<el-table-column label="ID" prop="userID" width="100" align="center" />
			<el-table-column label="宏云号" prop="loginName" align="center" show-overflow-tooltip />
			<el-table-column label="昵称" prop="nickname" align="center" show-overflow-tooltip />
			<el-table-column label="手机号" prop="mobilePhone" align="center" />
			<el-table-column label="邮箱" prop="loginEmail" align="center" />
			<el-table-column label="性别" align="center" width="40">
				<template slot-scope="scope">
					{{ scope.row.sex | sexTransform }}
				</template>
			</el-table-column>
			<el-table-column label="创建时间" align="center" width="95">
				<template slot-scope="scope">
					{{ scope.row.createDate | formatDate }}
				</template>
			</el-table-column>
      <el-table-column label="登录次数" prop="loginCount" align="center" width="57"/>
			<el-table-column label="最近登录" align="center">
				<template slot-scope="scope">
					{{ scope.row.lastLoginTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column v-if="userTypefilterOptions.length > 0" label="用户类型" prop="userType" align="center" width="60">
				<template slot-scope="scope">
					{{scope.row.userType | userTypeTransform}}
				</template>
			</el-table-column>
			<el-table-column label="账号状态" align="center" width="80">
				<template slot-scope="scope">
					<el-tag size="medium" :type="scope.row.status == 0 ? 'danger' : ''">
						{{ scope.row.status | userStatusTransform }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="300" align="center">
				<template slot-scope="scope">
          <el-button size="small" type="primary" @click.stop="goToVideoDetail(scope.row)">
            编辑
          </el-button>
					<el-button size="small" :type="scope.row.showType ? 'success' : 'info'"
						@click.stop="recommendUser(scope.row)">
						{{ scope.row.showType ? "取消推荐" : "推荐" }}
					</el-button>
					<el-button size="small" :type="scope.row.status ? 'warning' : 'success'"
						@click.stop="forbiddenUser(scope.row)">
						{{ scope.row.status ? "停用" : "恢复" }}
					</el-button>
					<el-button size="small" type="danger" @click.stop="deleteUser(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background :total="totalCount" :page-size="pageSize"
			:current-page="currentPage" @current-change="currentChange" />

		<!-- 新增用户 -->
		<el-dialog destroy-on-close title="新增用户" :visible.sync="addUserDlg" width="60%">
			<el-form ref="addUserFormRef" :model="form" :rules="rules">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item v-if="userTypefilterOptions.length > 0" prop="userType" label="用户类型" :label-width="formLabelWidth">
							<el-radio-group v-model="form.userType">
                <el-radio v-for="item in userTypefilterOptions"  :label="item.value">{{item.name}}</el-radio>
								</el-radio-group>

						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="userBindRole" label="用户角色">
							<el-select v-model="form.userBindRole" multiple placeholder="请选择">
								<el-option v-for="item in roleOptions" :key="item.roleID" :label="item.roleName"
									:value="item.roleID" />
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item prop="loginName" label="宏云号" :label-width="formLabelWidth">
							<el-input v-model="form.loginName" autocomplete="off" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="nickname" label="昵称" :label-width="formLabelWidth">
							<el-input v-model="form.nickname" autocomplete="off" />
						</el-form-item>
					</el-col>

				</el-row>

				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item prop="firstName" label="姓" :label-width="formLabelWidth">
							<el-input v-model="form.firstName" autocomplete="off" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="lastName" label="名" :label-width="formLabelWidth">
							<el-input v-model="form.lastName" autocomplete="off" />
						</el-form-item>
					</el-col>

				</el-row>

				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="密码" prop="password" :label-width="formLabelWidth">
							<el-input v-model="form.password" show-password type="password"
								autocomplete="new-password" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="确认密码" prop="passConfirm" :label-width="formLabelWidth">
							<el-input v-model="form.passConfirm" show-password type="password" autocomplete="off" />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item prop="mobilePhone" label="手机号" :label-width="formLabelWidth">
							<el-input v-model="form.mobilePhone" autocomplete="off" />
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="loginEmail" label="邮箱" :label-width="formLabelWidth">
							<el-input v-model="form.loginEmail" autocomplete="off" />
						</el-form-item>
					</el-col>


				</el-row>

				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="性别" :label-width="formLabelWidth">
							<el-radio-group v-model="form.sex">
								<el-radio label="0">男</el-radio>
								<el-radio label="1">女</el-radio>
								<el-radio label="2">未知</el-radio>
							</el-radio-group>

						</el-form-item>
					</el-col>

					<el-col :span="8">
						<el-form-item label="出生日期" :label-width="formLabelWidth">
							<el-date-picker v-model="form.date" type="date" placeholder="选择日期"
								style="width: 287.33px" />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="16">
						<el-form-item label="单位" :label-width="formLabelWidth">
							<el-input v-model="form.organization" autocomplete="off" />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="16">
						<el-form-item label="地址" :label-width="formLabelWidth">
							<el-input v-model="form.address" autocomplete="off" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click.stop="addUserDlg = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="addUser">
					保 存
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAllUserList,
		forbiddenUser,
		recommendUser,
		deleteUser,
		registerUser
	} from "@/api/userManagement"
	import {
		getRoleList,
		userBindRole,
	} from "@/api/role";
	import {
		isVaild
	} from "@/utils/validate"

	import md5 from "js-md5";
	import {
		generateRandomString
	} from "@/utils/stringutil.js"

	import {
		export_json_to_excel
	} from "@/vendor/Export2Excel.js"
  import {getUserType} from "@/utils/userutil";
  import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
  import {addDateTime, DateTimeField, getTimeFromString} from "@/utils/DateUtils";

	export default {
		data() {
			/**
			 * 两次密码验证
			 */
			const validatePassConfirm = (rule, value, callback) => {
				if (!isVaild(value)) {
					callback(new Error('请输入确认密码'))
				} else if (value !== this.form.password) {
					callback(new Error("两次密码输入不一致"))
				} else {
					callback()
				}
			}

			/**
			 * 宏云号验证
			 */
			const validateLoginName = (rule, value, callback) => {
				if (!isVaild(value)) {
					callback(new Error('请输入宏云号'))
				} else {
					callback()
				}
			}

      /**
       * 手机号验证
       */
      const validateMobilePhone = (rule, value, callback) => {
        // if(isVaild(this.form.loginEmail)){
        //   callback()
        //   return
        // }
        if (!isVaild(value)) {
          callback(new Error('请输入手机号'))
        } else {
          var reg = new RegExp("^[0-9]*$");
          if(!reg.test(value)){
            callback(new Error("手机格式不正确"));
          }else{
            callback()
          }
        }
      }


			return {
        navigationKey:"userList",

				//用户类型搜索
				userTypefilterOptions: [],
				curUserTypeFilterOption: "",
				loading: false, // 加载开关
				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				searchDateRange: "",
				pickerOptions: {
					// 时间不能大于当前时间
					disabledDate: time => {
						return time.getTime() > Date.now()
					},
					shortcuts: [{
							text: '一周内',
							onClick(picker) {
                let end = new Date(getTimeFromString(`${new Date().format("yyyy-MM-dd")} 00:00:00`))
								const start = new Date()
								// start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                start.setTime(addDateTime(end.getTime(),DateTimeField.Day,-6))
								picker.$emit('pick', [start, end])
							},
						},
						{
							text: '一个月内',
							onClick(picker) {
                let end = new Date(getTimeFromString(`${new Date().format("yyyy-MM-dd")} 00:00:00`))
								const start = new Date()
								// start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                start.setTime(addDateTime(end.getTime(),DateTimeField.Month,-1))
                //不是从12.06到1.06，是从12.07到1.06
                start.setTime(addDateTime(start.getTime(),DateTimeField.Day,1))
								picker.$emit('pick', [start, end])
							},
						},
						{
							text: '三个月内',
							onClick(picker) {
                let end = new Date(getTimeFromString(`${new Date().format("yyyy-MM-dd")} 00:00:00`))
								const start = new Date()
								// start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                start.setTime(addDateTime(end.getTime(),DateTimeField.Month,-3))
                //不是从12.06到1.06，是从12.07到1.06
                start.setTime(addDateTime(start.getTime(),DateTimeField.Day,1))
								picker.$emit('pick', [start, end])
							},
						},
					]
				},
				allUserList: [], // 所有用户列表
				addUserDlg: false, // 新增用户对话框
				typeRadio: "1",
				roleOptions: [],
				form: {},
				formLabelWidth: "80px",
				rules: {
          mobilePhone:[{
            required: true,
            validator: validateMobilePhone,
            trigger: ['blur']
          }],
					loginEmail: [{
            required: true,
            message: "请输入邮箱",
            trigger: ['blur']
          },{
						type: "email",
						message: '邮箱格式不正确',
						trigger: ['blur']
					}],
					loginName: [{
						required: true,
						message: "请输入宏云号",
						trigger: ['blur']
					}, {
						validator: validateLoginName,
						trigger: ['blur']
					}],
					nickname: [{
						required: true,
						message: "请输入昵称",
						trigger: ['blur', 'change']
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: ['blur']
					}, {
						min: 8,
						message: '密码至少8位',
						trigger: ['blur']
					}, ],
					passConfirm: [{
						validator: validatePassConfirm,
						trigger: ['blur']
					}],
					firstName: [{
						required: true,
						message: "请输入姓",
						trigger: ['blur']
					}],
					lastName: [{
						required: true,
						message: "请输入名",
						trigger: ['blur']
					}],
				},
				//导出excel相关
				exportLoading: false

			}
		},
		created() {
      let navigationObj = getNavigationItemObj(this.navigationKey)
      this.searchValue = navigationObj.searchValue
      this.currentPage = navigationObj.currentPage
      this.curUserTypeFilterOption = navigationObj.curUserTypeFilterOption
      this.searchDateRange = navigationObj.searchDateRange
      this.userTypefilterOptions = getUserType()
			this.refreshCurrentList();
			this.getRoleList();
			this.resetAddUserForm();
		},
		methods: {
			getLoginName() {
				return "yun_" + generateRandomString(7)
			},
			resetAddUserForm() {
        //清除数据
        this.form = {}
				this.form = {
					userType: "0",
					loginName: this.getLoginName(),
					sex: "2",
					curUserTypeFilterOption: "2"
				}
			},
			/**
			 * 获取所有角色列表
			 */
			getRoleList() {
				getRoleList().then((res) => {
          return res.data.totalCount
        }).then((res) => {
          return getRoleList({
            pageSize: res
          })
        }).then((res) => {
					this.roleOptions = res.data.result.map((e) => {
						return {
							roleID: e.roleID,
							roleName: e.roleName,
						};
					});
				});
			},
			/**
			 * 刷新列表
			 */
			refreshCurrentList() {

				this.getAllUserList();
			},
			/**
			 * 搜索
			 */
			search() {
				this.currentPage = 1;
				this.refreshCurrentList();
			},
			/**
			 * 重置
			 */
			reset() {
				this.searchValue = "";
				this.refreshCurrentList();
			},
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.refreshCurrentList();
			},
			disabledDate(time) {
				return time.getTime() > Date.now()
			},
			/**
			 * 获取所有用户列表
			 */
			getAllUserList() {
				this.loading = true;
				const params = {
					sortName: "",
					sortOrder: "",
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					userDataType: isVaild(this.curUserTypeFilterOption) ? this.curUserTypeFilterOption : "2",
					keyWord: this.searchValue,
				};
				if (isVaild(this.searchDateRange)) {
					params.where = [{
							"field": "createDate",
							"value": "'" + this.searchDateRange[0] + "'",
							"op": "greaterorequal"
						},
						{
							"field": "createDate",
							"value": "'" + this.$options.filters["formatDateTime"](addDateTime(this.searchDateRange[1],DateTimeField.Day,1))   + "'",
							"op": "lessorequal"
						}
					]
				}
        setNavigationItemWithObj(this.navigationKey,{
          currentPage:this.currentPage,
          searchValue:this.searchValue,
          curUserTypeFilterOption:this.curUserTypeFilterOption,
          searchDateRange:this.searchDateRange
        })
				getAllUserList(params).then((res) => {
					this.allUserList = res.data.rows;
					this.totalCount = res.data.total;
					this.utils.stopLoading(this);
				});
			},
			/**
			 * 修改单个用户状态(停用/正常)
			 *
			 * @param {object} row 所选对象信息
			 */
			forbiddenUser(row) {
				const params = {
					userID: row.userID,
					status: row.status === 1 ? 0 : 1,
				};
				forbiddenUser(params).then(() => {
					this.$message({
						type: "success",
						message: "设置成功!",
					});
					this.refreshCurrentList();
				});
			},
			/**
			 * 修改单个用户状态(推荐用户)
			 *
			 * @param {object} row 所选对象信息
			 */
			recommendUser(row) {
				const params = {
					userID: row.userID,
					showType: row.showType === 1 ? 0 : 1,
				};
				recommendUser(params).then(() => {
					this.$message({
						type: "success",
						message: "设置成功!",
					});
					this.refreshCurrentList();
				});
			},
			/**
			 * 删除单个用户
			 *
			 * @param {object} row 所选对象信息
			 */
			deleteUser(row) {
				const params = {
					userID: row.userID,
				};
				this.$confirm("是否删除该用户", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteUser(params).then(() => {
							this.$message({
								type: "success",
								message: "删除成功",
							});
							this.refreshCurrentList();
						});
					})
					.catch(() => {
						this.$message("取消操作");
					});
			},
			/**
			 * 跳转到用户详情
			 *
			 * @param {object} row 所选对象信息
			 */
			goToVideoDetail(row) {
				this.$router.push({
					path: "userDetail",
					query: {
						userID: row.userID,
					},
				});
			},
			/**
			 * 编辑用户
			 */
			editExpert(index, row) {
				console.log(index, row);
				this.addUserDlg = true;
			},

			/**
			 * 添加新用户
			 */
			async addUser() {
				this.$refs.addUserFormRef.validate(async (value) => {
					// if (!(this.form.mobilePhone || this.form.loginEmail)) {
					// 	this.$message.warning("手机或者邮箱必须填写一个")
					// 	return
					// }
					this.loading = true;
					if (value) {
						// this.addUserDlg = false
						this.addUserDlg = false
						const data = this.form;
						data.password = md5(data.password)
						if (!isVaild(data.loginName)) {
							data.loginName = "yun_" + generateRandomString(7)
						}
						let registerRes = await registerUser(data)
						console.log("registerRes " + registerRes)
						if (!isVaild(registerRes) || registerRes.code !== 200) {
							this.form.password = ""
							this.form.passConfirm = ""
							this.utils.stopLoading(this);
							this.$message({
								type: "danger",
								message: registerRes.message
							})
							return;
						}
						const params = {
							userID: registerRes.data.userID,
							roleIDArray: this.form.userBindRole.length === 0 ? '' : this.form
								.userBindRole,
						};
						let bindRoleRes = await userBindRole(params);
						if (bindRoleRes.code === 200) {
							this.$message({
								type: "info",
								message: "注册成功"
							})
						} else {
							this.$message({
								type: "danger",
								message: registerRes.message
							})
						}
						this.resetAddUserForm()
						if (this.currentPage === 1) {
							this.refreshCurrentList();
						}

						this.form.password = ""
						this.form.passConfirm = ""
						this.utils.stopLoading(this);

					} else {
						this.$message({
							type: "info",
							message: "提交数据有误"
						})
            this.utils.stopLoading(this);
					}
				})
			},
			/**
			 * 用户类型筛选条件改变
			 */
			changeUserTypeOption() {
				this.currentPage = 1;
				this.refreshCurrentList();
			},
			/**
			 * 导出 excel
			 */
			async export2Excel() {
				if (this.totalCount === 0) {
					this.$message("没有数据需要导出")
					return;
				}
				this.exportLoading = true;
				var tHeader = [
					"ID",
					"宏云号",
					"昵称",
					"手机号",
					"邮箱",
					"性别",
					"创建日期",
					"最后登录时间",
					"登录次数",
					"当前状态",
				];
        if(this.userTypefilterOptions.length > 0){
          tHeader.push("用户类型")
        }
				var filterVal = [
					"userID",
					"loginName",
					"nickname",
					"mobilePhone",
					"loginEmail",
					"sex",
					"createDate",
					"lastLoginTime",
					"loginCount",
					"status",
				];
        if(this.userTypefilterOptions.length > 0){
          filterVal.push("userType")
        }
				//获取全部数据
				const params = {
					sortName: "",
					sortOrder: "",
					pageSize: this.totalCount,
					userDataType: isVaild(this.curUserTypeFilterOption) ? this.curUserTypeFilterOption : "2",
					keyWord: this.searchValue,
				};
				if (isVaild(this.searchDateRange)) {
					params.where = [{
							"field": "createDate",
							"value": "'" + this.searchDateRange[0] + "'",
							"op": "greaterorequal"
						},
						{
							"field": "createDate",
							"value": "'" + this.searchDateRange[1] + "'",
							"op": "lessorequal"
						}
					]
				}
				const getAllUserListRes = await getAllUserList(params);
				console.log("getAllUserListRes" + getAllUserListRes)
				if (!isVaild(getAllUserListRes) || getAllUserListRes.code !== 200) {
					this.$message("获取数据失败，" + getAllUserListRes.message)
					this.exportLoading = false;
					return;
				}
				const data = this.formatJson(filterVal, getAllUserListRes.data.rows);
				export_json_to_excel({
					header: tHeader,
					data,
					filename: "用户列表",
					autoWidth: true,
					bookType: "xlsx",
				});
				this.exportLoading = false;

			},
			formatJson(filterVal, jsonData) {
				return jsonData.map((v) =>
					filterVal.map((j) => {
						if (j === "status") {
							return this.$options.filters["userStatusTransform"](v[j])
						} else if (j === 'sex') {
							return this.$options.filters["sexTransform"](v[j])
						} else if (j === 'userType') {
							return this.$options.filters["userTypeTransform"](v[j])
						}
						return v[j];
					})
				);
			},
		},
	}
</script>

<style>
</style>
